<template>
  <div class="event">
    <p class="event__title h3">{{ eventName }}</p>

    <AppMenu
      v-model="activeMenuItem"
      :items="menuItems"
      class="event__menu"
    />

    <KeepAlive>
      <component :is="componentName" />
    </KeepAlive>
  </div>
</template>

<script>
import AppMenu from '@/components/AppMenu'
import AppInformation from './components/AppInformation'
import AppUsers from './components/AppUsers'

export default {
  name: 'eventPage',
  components: {
    AppMenu,
    AppInformation,
    AppUsers
  },
  data () {
    return {
      eventName: 'Событие',
      activeMenuItem: this.$route.query.tab ?? 'information',
      menuItems: [
        { value: 'information', label: 'Информация', component: 'AppInformation' },
        { value: 'users', label: 'Участники', component: 'AppUsers' }
      ]
    }
  },
  computed: {
    componentName () {
      return this.menuItems
        .find(item => item.value === this.activeMenuItem).component
    }
  },
  watch: {
    activeMenuItem (newValue) {
      this.$router.push({
        path: this.$route.fullPath,
        query: { tab: newValue }
      })
    }
  },
  created () {
    this.fetchEventData()
  },
  methods: {
    async fetchEventData () {
      const id = this.$route.params.id

      try {
        const { data } = await this.$api.events.event(id)
        this.eventName = data?.title
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.event {
  &__menu {
    margin-bottom: 20px;
  }
}
</style>
